const SuppliersGroup = [
  {
    path: '/ecommerce/supply/suppliers-groups',
    name: 'suppliers-groups',
    component: () => import(/* webpackChunkName: "suppliers-group" */ './SuppliersGroupView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Suppliers Groups',
          path: '/ecommerce/supply/suppliers-groups',
        },
      ],
    },
  },
];

export default SuppliersGroup;
